const Builder = require('../BuilderBase');

module.exports = class ToNumber extends Builder {
    constructor(properties) {
        super('transform_ToNumber', '', properties);
    }
};
